import SalesDataImportConstants from "../../constants/SalesDataImportConstants";
import ISalesDataImport from "../../interfaces/ISalesDataImport";

const uploadSalesDataImport = (data: ISalesDataImport) => ({
    type: SalesDataImportConstants.UPLOAD_SALES_DATA,
    payload: data
});

export { uploadSalesDataImport };
